const pollActions = {
  subscribePollUpdateAction: async ({ dispatch }, { slide }) => {
    if (!slide || !slide.id) return null
    dispatch('subscribeCountingForSlideAction', { slide, answerer: true })

    const slideId = slide.id
    return function unsubscribeFn() {
      dispatch('unsubscribePollUpdateAction', {
        slideId, slide,
      })
    }
  },

  unsubscribePollUpdateAction: async ({ dispatch }, { slideId, slide }) => {
    if (!slideId) return
    if (slide) {
      dispatch('unsubscribeCountingForSlideAction', { slide, answerer: true })
    }
  },
}

export default pollActions
